import type { CostLineIndexEntry } from "../data/cost-engine-validation-types";
import type { RollingValidationView } from "./cost-engine-validation-presentation";

/**
 * The Live costing › Checks tab's default view (product-owner decision,
 * 12 Sep, docs/features/cost-engine-productionisation/
 * 03_manufacturing_surfaces_design.md "IA — Manufacturing nests under
 * Settings › Catalogue as Live costing"): open on **by cost line** when any
 * cost line is in Mismatch — that is the view a print manager needs to act
 * on — otherwise fall back to **by item**, the everyday overview.
 */
export function defaultLiveCostingChecksView(
  costLines: Pick<CostLineIndexEntry, "health">[],
): RollingValidationView {
  return costLines.some((line) => line.health === "red") ? "cost-line" : "item";
}
